import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import Table from "./Table";
import TableContext from "./TableContext";
import { fromJS } from "immutable";

var mql = function mql(width) {
  return window.matchMedia("(min-width: ".concat(width, "px)"));
};

var SimpleTable =
/*#__PURE__*/
function (_Component) {
  _inherits(SimpleTable, _Component);

  function SimpleTable(props) {
    var _this;

    _classCallCheck(this, SimpleTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleTable).call(this, props));

    _this.filterRows = function (_ref) {
      var sortState = _ref.sortState,
          sortEffect = _ref.sortEffect;

      var newSortState = _objectSpread({}, sortEffect, {
        sort: sortState.sort
      });

      _this.setState(function (state) {
        return {
          filteredRows: sortEffect.sortedRows,
          sortState: newSortState
        };
      });
    };

    _this.mediaQueryChanged = function () {
      _this.setState({
        mobile: !mql(_this.props.mobileWidth).matches
      });
    };

    _this.state = {
      mobile: !mql(_this.props.mobileWidth).matches,
      filteredRows: undefined,
      sortState: undefined
    };
    return _this;
  }

  _createClass(SimpleTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      mql(this.props.mobileWidth).addListener(this.mediaQueryChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      mql(this.props.mobileWidth).removeListener(this.mediaQueryChanged);
    }
  }, {
    key: "createWrapperStyling",
    value: function createWrapperStyling(fontSize) {
      if (this.props.expandedStatus) {
        return {
          height: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          paddingTop: "3px",
          fontSize: fontSize ? fontSize : "10px"
        };
      } else {
        return {
          height: "100%"
        };
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.children && nextProps.children.get("rows") && nextProps.children.get("rows").size > 0) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          expandedStatus = _this$props.expandedStatus,
          config = _this$props.config,
          link = _this$props.link,
          preRowRender = _this$props.preRowRender,
          customRowRenderer = _this$props.customRowRenderer,
          onRowClick = _this$props.onRowClick,
          rowHeight = _this$props.rowHeight,
          fontSize = _this$props.fontSize,
          maxHeight = _this$props.maxHeight,
          useSort = _this$props.useSort,
          useFooter = _this$props.useFooter;

      if (this.state.mobile && !expandedStatus) {
        return React.createElement("div", {
          style: {
            height: "100%"
          },
          "data-testid": "mobile-table"
        }, this.props.mobileTable());
      } else {
        return React.createElement("div", {
          style: this.createWrapperStyling(fontSize)
        }, React.createElement(AutoSizer, null, function (_ref2) {
          var width = _ref2.width,
              height = _ref2.height;
          return React.createElement(TableContext.Provider, {
            value: {
              list: children ? children.get("rows") : fromJS([]),
              filterRows: _this2.filterRows,
              filteredRows: _this2.state.filteredRows,
              sortState: _this2.state.sortState
            }
          }, React.createElement(Table, {
            link: link,
            width: width,
            height: height,
            maxHeight: maxHeight,
            config: config,
            preRowRender: preRowRender,
            customRowRenderer: customRowRenderer,
            onRowClick: onRowClick,
            rowHeight: rowHeight,
            useSort: useSort,
            useFooter: useFooter,
            footer: children ? children.get("footer") : fromJS([])
          }, children));
        }));
      }
    }
  }]);

  return SimpleTable;
}(Component);

export default SimpleTable;